/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';
import { OverlayTrigger, Tooltip, Collapse } from 'react-bootstrap';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';
import { applyReasons } from '../constant/loan';
import { isDesktop } from 'react-device-detect';
import { verifySign } from '@api';
const ApplyModal = () => {
    // 簽驗
    const [certificateNumber, setCertificateNumber] = useState('');
    let tempObj = {};
    const [veriObj, setVeriObj] = useState({});
    function sign_callback(obj) {
        tempObj = {};
        tempObj.signature = obj.signed;
        tempObj.serial = obj.casno;
        tempObj.data = idno.trim() + ',loan';
        setVeriObj(tempObj);
        setCertificateNumber(obj.casno);
    }
    async function CGSign() {}
    async function verifySignFunc(veriObj) {
        const res = await verifySign(veriObj);
        if (res.data.code === '0') {
            setCertificateNumber(veriObj.serial);
        } else {
            // todo modal res.data.message
        }
        return res;
    }
    // 簽驗結束
    const [open, setOpen] = useState(false);
    const {
        LoanStore: {
            amount,
            applyReason,
            applyModalVisible,
            applyDisabled,
            closeApplyModal,
            updateData,
            apply,
            collateralList,
            getLendBusinessTime,
            transType,
        },
        AuthStore: {
            collectionDeliveryBankAccountCode,
            collectionDeliveryBankAccount,
            collectionDeliveryBankAccountName,
            interestRate,
            updateUserInfo,
            deadLine,
            borrowedAmount,
            idno,
        },
    } = useStore();
    useEffect(() => {
        if (!applyModalVisible) {
            setOpen(false);
        } else {
            if (!signWeb) {
                // 測試機關閉簽驗
                setCertificateNumber('test');
            } else {
                // 打開先簽章
                if (!isDesktop) {
                    const signObj = {
                        cb: sign_callback,
                    };
                    signObj.idno = idno.trim();
                    signObj.tosign = idno.trim() + ',loan';
                    // P1
                    signObj.method = 'P7';
                    // eslint-disable-next-line no-undef
                    mtklib.sign(signObj);
                } else {
                    // 判斷web還是ap?
                    console.log(!!window.chrome.webview);
                    const capiobj = getCGCAPIATLADPTObj();
                    if (capiobj !== undefined) {
                        console.log('載入成功 !');
                        if (capiobj.NeedUpdateInstaller()) {
                            // 檢查是否有新版本要版更
                            const msg =
                                '已有新版[簽章ServiSign]元件，請重新下載及手動安裝元件後，再重新執行網頁!';
                            updateData('errMsg', msg);
                            updateData('certModalVisible', true);
                            closeApplyModal();
                            return;
                        }
                    } else {
                        console.log('載入失敗 !');
                        updateData('errMsg', '全景程式載入失敗');
                        updateData('certModalVisible', true);
                        closeApplyModal();
                        return;
                    }
                    const iKeyUsage = 0;
                    const strCSP = '';
                    const iHashFlags = 0x04; // SHA256

                    const text = idno.trim() + ',loan'; // 簽章原文
                    let SignDataPC = '';
                    const id1 = 'CN=TW' + idno.trim() + '1'; // 身分證號

                    const strSubject = id1 + '\nOU=PSCNET'; // 統一證券OU
                    const strIssuer = '';
                    const strPin = '';

                    const iFlags =
                        CGCAPI_FLAG_SELCERT_AUTO +
                        '|' +
                        CGCAPI_FLAG_SELCERT_CHECKVALID;

                    let min = 10000;

                    const t1 = new Date().getTime();

                    SignDataPC = capiobj.CAPISign(
                        text,
                        'MS950',
                        strSubject,
                        strIssuer,
                        strCSP,
                        '',
                        iFlags,
                        iHashFlags,
                        iKeyUsage
                    ); // strIssure, strCSP, iKeyUsage固定
                    const t2 = new Date().getTime();
                    if (t2 - t1 < min) min = t2 - t1;
                    const rtn = capiobj.GetErrorCode();

                    if (rtn !== 0) {
                        updateData(
                            'errMsg',
                            '簽章失敗!錯誤代碼:' + GetErrorMessage(rtn)
                        );
                        updateData('certModalVisible', true);
                        closeApplyModal();
                    } else {
                        // 簽章成功取憑證序號
                        const subject = 'CN=TW' + idno.trim() + '1\nOU=PSCNET';
                        const flag =
                            CGCAPI_FLAG_SELCERT_AUTO +
                            '|' +
                            CGCAPI_FLAG_SELCERT_CHECKVALID;
                        const cert = capiobj.CAPI_XGetUserCertificate(
                            '',
                            subject,
                            flag,
                            0,
                            ''
                        ); // provider, keyusage, 第五個欄位為固定值
                        let rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            updateData('errMsg', '取得使用者憑證失敗' + rtn);
                            updateData('certModalVisible', true);
                            closeApplyModal();
                            return;
                        }
                        // 憑證取得序號
                        const serial = capiobj.CAPICertGetSerialNumber(cert, 0);
                        rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            updateData(
                                'errMsg',
                                '取得憑證序號失敗!錯誤代碼:' +
                                    GetErrorMessage(rtn)
                            );
                            updateData('certModalVisible', true);
                            closeApplyModal();
                            return;
                        }
                        tempObj = {};
                        tempObj.signature = SignDataPC;
                        tempObj.serial = serial;
                        tempObj.data = idno.trim() + ',loan';
                        setVeriObj(tempObj);
                        setCertificateNumber(tempObj.serial);
                    }
                    // setCertificateNumber('web');
                }
            }
        }
    }, [applyModalVisible]);
    return (
        <>
            <Modal
                show={applyModalVisible}
                onHide={closeApplyModal}
                title={'確認借款資料'}
            >
                <form
                    onSubmit={async e => {
                        e.preventDefault();
                        // 簽驗
                        if (!signWeb) {
                            // 測試機關閉簽驗
                            updateData('certificateNumber', certificateNumber);
                        } else {
                            const verifyResult = await verifySignFunc(veriObj);
                            updateData('certificateNumber', certificateNumber);
                            if (verifyResult.data.code !== '0') {
                                updateData('errMsg', verifyResult.data.message);
                                updateData('certModalVisible', true);
                                closeApplyModal();
                                return;
                            }
                        }
                        // 簽驗結束
                        updateData('applyDisabled', true);
                        const loanSwitch = await getLendBusinessTime();
                        if (loanSwitch) {
                            closeApplyModal();
                            if (
                                transType === 'E1' ||
                                transType === 'E2' ||
                                transType === 'E3'
                            ) {
                                updateData('transInfoModalVisible', true);
                                updateData('applyDisabled', true);
                            } else {
                                updateData('transInfoModalVisible', false);
                                updateData('applyDisabled', false);
                                updateData(
                                    'amount',
                                    removeNonNumeric(
                                        Math.floor(amount / 1000) * 1000
                                    )
                                );
                                await apply();
                                updateUserInfo();
                            }
                        } else {
                            closeApplyModal();
                        }
                    }}
                >
                    <div className="border-0">
                        <h4 className="title fw-bolder mb-2">
                            請您確認以下申請資料
                        </h4>
                        <ul className="apply-info scrol-opacity table-responsive d-flex flex-nowrap justify-content-between align-items-end text-center mb-2">
                            <li className="px-1 pt-2 pb-1 order-3 order-md-0">
                                <h6 className="red fs-15">
                                    {applyReasons
                                        .filter(i => i.value === applyReason)
                                        .map(i => i.label)}
                                    {/* {applyReasons[applyReason].label}
                                {applyReasons[applyReason].value === '07' &&
                                    `: ${applyReasonOther}`} */}
                                </h6>
                                <small className="fs-12">借款目的</small>
                            </li>
                            <li className="px-1 pt-2 pb-1 position-relative">
                                <h6 className="red">
                                    <span>{interestRate}</span>%
                                </h6>
                                <small className="fs-12">適用利率</small>
                            </li>
                            <li className="px-1 pt-2 pb-1">
                                <h6 className="red fs-15">{deadLine}</h6>
                                <small className="fs-12">借款到期日</small>
                            </li>
                        </ul>
                        <span
                            type="button"
                            className="fs-15 text-end text-decoration-underline d-block"
                            onClick={() => setOpen(!open)}
                        >
                            擔保品清單
                        </span>
                        <Collapse in={open}>
                            <div
                                id="security-list"
                                className="collapse toggle-sty position-relative  mt-2 mb-3"
                            >
                                <ul className="stock-list d-sm-none">
                                    {collateralList.map(
                                        (
                                            {
                                                stockNo,
                                                stockName,
                                                qty,
                                                closePrice,
                                                marketVal,
                                            },
                                            idx
                                        ) => {
                                            return (
                                                <li
                                                    key={`collateralList ${idx}`}
                                                    className="d-flex flex-wrap py-2 px-3 mb-3"
                                                >
                                                    <div className="stock-choose d-flex mb-2">
                                                        <div className="stock-name text-black2">
                                                            <span className="me-2">
                                                                {stockNo}
                                                            </span>
                                                            {stockName}
                                                        </div>
                                                        <div className="stock-number d-flex ms-2 align-items-baseline">
                                                            <small className="gray-light me-1">
                                                                張數
                                                            </small>
                                                            <span className="text-black2">
                                                                {qty}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-baseline">
                                                        <div className="stock-number d-flex align-items-baseline">
                                                            <small className="gray-light me-1">
                                                                收盤
                                                            </small>
                                                            <span className="price text-black2">
                                                                $ {closePrice}
                                                            </span>
                                                        </div>
                                                        <div className="stock-number d-flex mx-3 align-items-baseline">
                                                            <small className="gray-light me-1">
                                                                市值
                                                            </small>
                                                            <span className="price text-black2">
                                                                {addCommas(
                                                                    removeNonNumeric(
                                                                        marketVal
                                                                    )
                                                                )}
                                                            </span>
                                                        </div>
                                                        {/* <div className="stock-number d-flex align-items-baseline">
                                                        <small className="gray-light me-1">
                                                            融通
                                                        </small>
                                                        <span
                                                            className={`fingbox rounded-3 text-center ${
                                                                !accommodating
                                                                    ? 'opacity-50'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {accommodating}
                                                            <span>%</span>
                                                        </span>
                                                    </div> */}
                                                    </div>
                                                </li>
                                            );
                                        }
                                    )}
                                </ul>

                                <div className="table-freezes d-sm-block d-none overflow-hidden p-1">
                                    <table
                                        cellSpacing={0}
                                        className="table table_sty bg-white mb-0"
                                    >
                                        <thead>
                                            <tr>
                                                <th>股票代號</th>
                                                <th>股票名稱</th>
                                                <th>張數</th>
                                                <th>
                                                    <div className="h-r">
                                                        收盤價
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip>
                                                                    前一營業日收盤價
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                                        </OverlayTrigger>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="h-r2">
                                                        市值
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip>
                                                                    前一營業日市值
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                                        </OverlayTrigger>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {collateralList.map(
                                                (
                                                    {
                                                        stockNo,
                                                        stockName,
                                                        qty,
                                                        closePrice,
                                                        marketVal,
                                                    },
                                                    idx
                                                ) => {
                                                    return (
                                                        <tr
                                                            key={`collateralList ${idx}`}
                                                        >
                                                            <th>
                                                                <span className="co-name">
                                                                    {stockNo}
                                                                </span>
                                                            </th>
                                                            <td>{stockName}</td>
                                                            <td>
                                                                <div className="num_qut t-r3">
                                                                    {qty}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="num_price t-r3">
                                                                    <span>
                                                                        $
                                                                    </span>
                                                                    {closePrice}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="num_price t-r3">
                                                                    <span>
                                                                        $
                                                                    </span>
                                                                    {addCommas(
                                                                        removeNonNumeric(
                                                                            marketVal
                                                                        )
                                                                    )}
                                                                </div>
                                                            </td>
                                                            {/* <td>
                                                            <span
                                                                className={`fingbox rounded-3 text-center ${
                                                                    !accommodating
                                                                        ? 'opacity-50'
                                                                        : ''
                                                                }`}
                                                            >
                                                                {accommodating}
                                                                <span> %</span>
                                                            </span>
                                                        </td> */}
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Collapse>
                        <div>
                            <div className="formbox row g-4">
                                <div className="col-12">
                                    <label className="form-label">
                                        轉入帳戶
                                    </label>
                                    <li className="position-relative ">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={
                                                collectionDeliveryBankAccountName
                                            }
                                            disabled
                                        />
                                    </li>
                                </div>
                                <div className="col-12">
                                    <label className="form-label">
                                        銀行帳戶
                                    </label>
                                    <li className="position-relative">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={`${collectionDeliveryBankAccountCode}-${collectionDeliveryBankAccount}`}
                                            disabled
                                        />
                                    </li>
                                </div>
                                <div className="col-12">
                                    <label className="form-label">
                                        借款金額
                                    </label>
                                    <li className="red-num position-relative">
                                        <span className="fw-bolder position-absolute">
                                            $
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control fw-bolder"
                                            value={addCommas(
                                                removeNonNumeric(
                                                    Math.floor(
                                                        removeCommas(amount) /
                                                            1000
                                                    ) * 1000
                                                )
                                            )}
                                            disabled
                                        />
                                    </li>
                                </div>
                            </div>
                            <p className="text-danger text-start  fs-12 mt-2">
                                請確認申請資料，送出申請後則無法修改銀行帳戶和金額
                            </p>
                            <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                                <button
                                    className="btn_cancel btn rounded-pill  text-sm-center"
                                    type="button"
                                    onClick={() => {
                                        closeApplyModal();
                                    }}
                                >
                                    回上步
                                </button>
                                <button
                                    className="btn_check btn rounded-pill text-white"
                                    type="submit"
                                    disabled={
                                        applyDisabled ||
                                        parseInt(amount) > borrowedAmount
                                    }
                                >
                                    確認申請
                                    <p
                                        className={
                                            parseInt(amount) > borrowedAmount
                                                ? 'p-warn text-danger fs-12 fw-bolder'
                                                : 'd-none'
                                        }
                                    >
                                        尚可借金額不足
                                    </p>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal>
            {/* <CertModal msg={errMsg} /> */}
        </>
    );
};

export default observer(ApplyModal);
